export class AntennaModel{

    id: number;

    modelName: string;
    
    antennaFile: File;

    // modal variables
    selected: boolean = false;

    static mapToFormData(antennaModel: AntennaModel): FormData{
        const formData: FormData = new FormData();
        formData.append('modelName', antennaModel.modelName);
        antennaModel.id != null? formData.append("id", antennaModel.id.toString()): false;
        antennaModel.antennaFile != null? formData.append("antennaFile", antennaModel.antennaFile, antennaModel.antennaFile.name): false;
        return formData;
      }

}